import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import RevolutionizeImg from "../../images/location_new/fold7/Florida.webp";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Why Choose TekRevol for Mobile App Development in Florida?</h2>
            <p>
              TekRevol delivers an exceptional combination of innovation in our
              mobile app development services in Florida. Our agile methodology
              warrants swift iterations and compliance with changing trends and
              developing requirements. We offer affordable solutions without
              negotiating quality, making app development reachable to
              businesses of all scales. Keeping communication transparent is our
              goal, and keeping you well-versed throughout the process is what
              we strive for. Beyond deployment, we provide incessant maintenance
              and support, guaranteeing faultless app operation. Team up with
              TekRevol in Florida for a personalized, standout app development
              experience that sets your project apart from the rest.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
